<template>
  <div class="order-conform">
    <section class="dialog-header">
      <h1>Uw opdracht is verzonden</h1>
    </section>
    <section class="dialog-content">
      <form :action="url" method="POST" ref="sapForm">
        <p>
          U wordt binnen 10 seconden teruggeleid naar uw bestelomgeving waar u
          uw opracht verder kunt afronden. Wanneer u niet automatisch wordt
          teruggeleid, klik dan op de knop hieronder.
        </p>

        <input type="hidden" name="cxml-base64" :value="xml" />

        <div class="button-holder">
          <button type="submit" class="pill-button" @click="close">
            Doorgaan
          </button>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import { url } from '@vuelidate/validators'

export default {
  props: {
    url: {
      type: String,
      required: true
    },
    xml: {
      type: String,
      required: true
    }
  },
  data() {},
  mounted() {
    setTimeout(() => {
      this.sendForm()
    }, 5000)
  },
  created() {
    this.$router.push({ name: 'home' })
    this.rootStore.setHome()

    if (this.countdown > 0) {
      setTimeout(() => {
        this.close()
      }, this.countdown * 1000)
    }
  },
  methods: {
    sendForm() {
      // Simuleer formulier submit
      this.$refs.sapForm.submit()
    }
  },
  computed: {
    wantsConfirmation() {
      return this.rootStore.user.notificationPreferences.orderConfirmation || true
    }
  }
}
</script>

<style lang="scss" scoped></style>
